import { Navigate, Outlet } from 'react-router-dom';
import { useSession } from '../context/SessionContext.jsx';

/**
 * Client-side gate for the Vizora staff console.
 *
 * Convenience only. Every /api/platform route is independently guarded by
 * Entra group membership on the server and returns 404 to anyone else, so
 * bypassing this in the browser gains nothing. Customer administrators do
 * not qualify — portal admin and platform staff are separate authorities.
 */
export default function RequirePlatformAdmin() {
  const { isPlatformAdmin, isLoading } = useSession();
  if (isLoading) return null;
  if (!isPlatformAdmin) return <Navigate to="/" replace />;
  return <Outlet />;
}
